import { render, staticRenderFns } from "./CenterPage.vue?vue&type=template&id=43cada5e&scoped=true&"
import script from "./CenterPage.vue?vue&type=script&lang=ts&"
export * from "./CenterPage.vue?vue&type=script&lang=ts&"
import style0 from "./CenterPage.vue?vue&type=style&index=0&id=43cada5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cada5e",
  null
  
)

export default component.exports